import Styles from '@/Components/Header/HeaderTitle/HeaderTitle.module.scss';

function HeaderTitle({ title }: Readonly<{ title: string }>): React.ReactElement {
    return (
        <h4 className={Styles.title}>
            {title}
        </h4>
    );
}

export default HeaderTitle;
